/* istanbul ignore file */
const formattedOptimizely = function () {
  const startOptimizely = () => {
    if (!window.optimizely) return
    const { optimizely } = window
    // As instructued by Optimizely, create a cookie key optly_auction_test
    // to view the changes for the experiment
    let expiryDate = ''
    const expirationDays = 1
    const date = new Date()
    const cookieKey = 'optly_auction_test'
    date.setTime(`${date.getTime()}${expirationDays}`)
    expiryDate = `; expiryDate=" ${date.toUTCString()}`
    document.cookie = `${cookieKey}='' ${expiryDate}; path=/`

    const optimizelyData = optimizely.get('data')
    /* eslint-disable */
    console.info(
      `%c Optimizely Data`,
      'background: #036eb5; color: #fff; padding: 3px 6px;'
    )
    console.info(
      `%c ${JSON.stringify(optimizelyData, null, 3)}`,
      'background: #036eb5; color: #fff; padding: 3px 6px;'
    )
    /* eslint-disable */
  }

  const alreadyLoaded =
    document?.querySelectorAll('[id="optimizely-sdk"]')?.length > 0

  const message = alreadyLoaded
    ? '%c Optimizely previously loaded'
    : '%c Loading Optimizely'
  console.info(message, 'background: #036eb5; color: #fff; padding: 3px 6px;') // eslint-disable-line

  if (!alreadyLoaded) {
    const optimizelyScript = document.createElement('script')
    optimizelyScript.type = 'text/javascript'
    optimizelyScript.id = 'optimizely-sdk'
    optimizelyScript.src = 'https://cdn.optimizely.com/js/27307530788.js'
    document.body.appendChild(optimizelyScript)
    document
      ?.querySelector('#optimizely-sdk')
      .addEventListener('load', startOptimizely)
  } else {
    startOptimizely()
  }
}

export const getOptimizelyScript = () => `(${formattedOptimizely.toString()}())`
